<template>
    <v-dialog
        :value="isOpen"
        max-width="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Algorytm dla: <strong>{{ component.component.name }} ({{ component.component.code }}) - {{ property.productProductionProperty.name }}</strong>
                </h1>
            </v-card-title>

            <v-card-text v-if="filteredProperties.length > 0">
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <h2 class="text-body-2">
                                Cechy:
                            </h2>

                            <v-btn
                                v-for="item in filteredProperties"
                                :key="item.productProductionProperty.id"
                                :disabled="actionLoading"
                                color="secondary"
                                depressed
                                rounded
                                small
                                class="ma-1"
                                @click="addProductionProperty(item)"
                            >
                                {{ item.productProductionProperty.name }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-text>
                <v-text-field
                    v-model="algorithm"
                    :disabled="actionLoading"
                    clearable
                    label="Wpisz algorytm"
                    hint="Dozwolone działania: + - * / ( ) oraz nazwa cechy"
                    persistent-hint
                    outlined
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    :disabled="actionLoading"
                    color="error"
                    text
                    @click="onClose"
                >
                    Anuluj
                </v-btn>

                <v-spacer />

                <v-btn
                    :loading="actionLoading"
                    color="success"
                    text
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
export default {
    name: 'AssignProductionPropertyAlgorithmDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        component: {
            type: Object,
            default: null
        },
        property: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            algorithm: null,
            actionLoading: false
        }
    },
    computed: {
        filteredProperties() {
            return this.component.productTypeComponentProperties.filter(item => {
                return !item.productProductionProperty.isAlgorithmic
            })
        }
    },
    watch: {
        property(value) {
            this.algorithm = value.algorithm
        }
    },
    methods: {
        addProductionProperty(property) {
            if (!this.algorithm) {
                this.algorithm = property.productProductionProperty.name
            } else {
                this.algorithm += property.productProductionProperty.name
            }
        },
        onSave() {
            let payload = {
                productTypeComponentProperties: []
            }

            this.actionLoading = true

            this.component.productTypeComponentProperties.forEach(property => {
                payload.productTypeComponentProperties.push(
                    {
                        productProductionPropertyId: property.productProductionPropertyId,
                        algorithm: property.algorithm || null
                    }
                )
            })

            payload.productTypeComponentProperties[this.property.index].algorithm = this.algorithm

            this.$store.dispatch('configurations/validateProductionPropertyAlgorithm', payload)
                .then(response => {
                    this.onClose()
                    this.$emit('on-save', this.property.index, this.algorithm, response.data.usedProductionProperties)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        onClose() {
            setTimeout(() => {
                this.algorithm = null
            }, 500)

            this.$emit('on-close')
        }
    }
}
</script>
